var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mini-rhizome"},[_c('vue-p5',{on:{"setup":_vm.setup,"draw":_vm.draw}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }